import { ApiError } from '@/api/error/api.errors';
import { submitEventEnter } from '@/api/event';
import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import useEventEnterQuery from './useTermsEnterQuery';
import { UserData } from '@/api/event.types';
import { produce } from 'immer';

const useEventEnterMutation = (): UseMutationResult<void, ApiError, string> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: getMutationKey(),
    mutationFn: submitEventEnter,
    onSuccess: (_, eventId) => {
      queryClient.setQueryData<UserData>(
        useEventEnterQuery.getQueryKey(eventId),
        produce((draft) => {
          if (!draft) return;

          draft.user.isAvailable = false;
        }),
      );
    },
  });
};

const getMutationKey = () => ['event-enter'];
useEventEnterMutation.getMutationKey = getMutationKey;

export default useEventEnterMutation;
